import React, { useState, useEffect, useContext, Fragment } from "react";
import Layout from "components/sales/layout/layout";
import TableSection from "components/sales/tableSection/tableSection";
import EditCreditPopup from './EditCreditPopup';
import RetagInvoicePopup from './RetagInvoicePopup';
import { Button } from "react-bootstrap";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";

const CreditPolicy = ({
    creditListing,
    creditsList = [],
    teamListing,
    teamsList = []
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [showEditCreditPopup, setShowEditCreditPopup] = useState(false);
  const [showRetagInvoicePopup, setShowRetagInvoicePopup] = useState(false);
  const [roleId, setRoleId] = useState("");
  const [creditLimit, setCreditLimit] = useState("");
  const [creditExhausted, setCreditExhausted] = useState("");
  const [creditRemaining, setCreditRemaining] = useState("");
  const [responsibleEmail, setResponsibleEmail] = useState("");
  const [responsibleDepartment, setResponsibleDepartment] = useState("");
  const [departmentName, setDepartmentName] = useState(0);
  const [userName, setUserName] = useState('');
  const [type, setType] = useState('');
  const [monthlyAverageRevenue, setMonthlyAverageRevenue] = useState(0);
  const [employeeCreditLimit, setEmployeeCreditLimit] = useState(0);
  const [employeeCreditRemaining, setEmployeeCreditRemaining] = useState(0);
  const [userId, setUserId] = useState(0);
  const [departmentId, setDepartmentId] = useState(0);
  const [expectedCreditLimit, setExpectedCreditLimit] = useState(0);
  const [teamId, setTeamId] = useState(0);
  const [teamName, setTeamName] = useState("");
  const [employeeResponsibleEmail, setEmployeeResponsibleEmail] = useState("");
  const [employeeResponsibleDepartment, setEmployeeResponsibleDepartment] = useState("");
  const [employeeDepartmentId, setEmployeeDepartmentId] = useState("");
  const [employeeTeamId, setEmployeeTeamId] = useState(0);
  const [employeeTeamName, setEmployeeTeamName] = useState("");
  const [selectedTeam, setSelectedTeam] = useState(() => {
    const savedTeam = localStorage.getItem('selectedTeam');
    return savedTeam ? JSON.parse(savedTeam) : null;
  })

  const Headers = [
    "Department",
    "Credit Limit",
    "Credit Exhausted",
    "Credit Remaining",
    "Expected Credit Limit",
    "Action"
  ];

  const EmployeeHeaders = [
    "Employee ID",
    "Employee Name",
    "Employee Status",
    "Department",
    "Team",
    "Credit Limit",
    "Credit Exhausted",
    "Credit Remaining",
    "Action"
  ];

  let currentUserDetails = localStorage.getItem('loginDetails');
  let parsedDetail = JSON.parse(currentUserDetails);
  let role_id = parsedDetail.roleId;
  let current_type = '';

  if(role_id == 49 || role_id == 13){
    current_type = 'D';
  }
  else{
    current_type = 'E';
  }

  let profileDetails = localStorage.getItem('profileDetails');
  let parsedProfileDetail = JSON.parse(profileDetails);
  let department_id = parsedProfileDetail[0].department_id;

  useEffect(() => {
    if(current_type === 'D'){
      const fetchData = async () => {
          setIsLoading(true);
          await creditListing(current_type,1);
          setIsLoading(false);
      };
      fetchData();
    }
  }, []);

  useEffect(() => {
    const fetchData = async () => {
        setIsLoading(true);
        await teamListing();
        setIsLoading(false);
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (!selectedTeam?.id) return;
  
    localStorage.setItem('selectedTeam', JSON.stringify(selectedTeam));
  
    const fetchData = async () => {
      setIsLoading(true);
      await creditListing(current_type, 1, department_id, selectedTeam?.id);
      setIsLoading(false);
    };
  
    fetchData();
  }, [selectedTeam]);
  
  
  useEffect(() => {
    if (!creditsList || !creditsList?.resultSets) return;
  
    let tableData = [];
  
    if (current_type === 'D') {
      tableData = [
        "id",
        "credit_department",
        "credit_limit",
        "credit_exhausted",
        "credit_remaining",
        "expected_credit_limit"
      ];
    } else {
      tableData = [
        "id",
        "user_id",
        "employee_name",
        "employee_status",
        "department_name",
        "team_name",
        "credit_limit",
        "credit_exhausted",
        "credit_remaining"
      ];
    }
  
    const data = creditsList.resultSets.map((element) => {
      let actions = [];
  
      if (element?.user_id) {
        actions.push({
          name: 'Edit Credit Limit',
          creditLimit: element.credit_limit || "0.00",
          creditExhausted: element.credit_exhausted || "0.00",
          creditRemaining: element.credit_remaining || "0.00",
          departmentName: element.department_name || "",
          departmentId: element.department_id || 0,
          userId: element.user_id || 0,
          userName: element.employee_name || "",
          monthlyAverageRevenue: element.monthly_average_revenue || "0.00",
          type: 'E',
          responsibleEmail: element.email || '',
          responsibleDepartment: element.department_name || '',
          teamName: element.team_name || 0,
          teamId: element.team_id || '',
        });
        if (element?.employee_status != 'ACTIVE') {
          actions.push({
            name: 'Retag Invoice',
            employeeCreditLimit: element.credit_limit || "0.00",
            employeeCreditRemaining: element.credit_remaining || "0.00",
            employeeResponsibleEmail: element.email || '',
            employeeResponsibleDepartment : element.department_name || '',
            employeeDepartmentId: element.department_id || 0,
            employeeTeamId: element.team_id || 0,
            employeeTeamName: element.team_name || ''
          });
        }
      } else {
        actions.push({
          name: 'Edit Credit Limit',
          creditLimit: element.credit_limit || "0.00",
          creditExhausted: element.credit_exhausted || "0.00",
          creditRemaining: element.credit_remaining || "0.00",
          departmentName: element.credit_department || "",
          departmentId: element.department_id || 0,
          userId: 0,
          userName: "",
          monthlyAverageRevenue: element.monthly_average_revenue || "0.00",
          type: 'D',
          responsibleEmail: element.email || '',
          responsibleDepartment: element.department_name || '',
          teamName: element.team_name || 0,
          teamId: element.team_id || '',
          expectedCreditLimit: element.expected_credit_limit || 0
        });
      }
  
      return {
        ...Object.fromEntries(tableData.map(key => [key, element[key]])),
        Action: actions
      };
    });
  
    data && setListData(data);
    setPageCount(Math.ceil(creditsList?.total / (creditsList?.per_page)));
  
  }, [creditsList]);     

  const onPageChange = async (val) => {
    setIsLoading(true);
    if(current_type == 'D'){
        await creditListing(current_type,val.selected + 1);
    }
    else{
        await creditListing(current_type,val.selected + 1,department_id, selectedTeam?.id);
    }
    setIsLoading(false);
  };

  const headerBtns = () => {
    return (
      <Fragment>
        <Button
          className="filter-hamburger btn btn-transparent">
          Total credit limit: {creditsList?.total_credit_limit ?? "0.00"}
        </Button>
        <Button
          className="filter-hamburger btn btn-transparent">
          Total credit exhausted: {creditsList?.total_credit_exhausted ?? "0.00"}
        </Button>
        <Button
          className="filter-hamburger btn btn-transparent">
          Total credit remaining: {creditsList?.total_credit_remaining ?? "0.00"}
        </Button>
      </Fragment>
    );
  };

  return (

    <>

    <Layout
      title="Credits Listing"
      Buttons={headerBtns}
      className={false ? "requiredFileds" : ""}
      isLoading={isLoading}
    >

      {current_type != 'D' &&
      
        <div className="mt-3 mb-3">
          <DropDownInput
            label="Select Team"
            data={teamsList}
            getIdValue={(val) =>{
              setSelectedTeam(val)
            }}
            value={selectedTeam?.value || ''}
            isStarRequired={true}
          />
        </div>

      }

      <TableSection
        data={listData}
        headers={current_type == "D" ? Headers : EmployeeHeaders}
        pageCount={pageCount}
        setShowEditCreditPopup={setShowEditCreditPopup}
        setShowRetagInvoicePopup={setShowRetagInvoicePopup}
        setCreditLimit = {setCreditLimit}
        setCreditExhausted = {setCreditExhausted}
        setCreditRemaining = {setCreditRemaining}
        setType = {setType}
        setUserId = {setUserId}
        setMonthlyAverageRevenue = {setMonthlyAverageRevenue}
        setUserName = {setUserName}
        setDepartmentId = {setDepartmentId}
        setDepartmentName = {setDepartmentName}
        setResponsibleEmail={setResponsibleEmail}
        setEmployeeCreditLimit={setEmployeeCreditLimit}
        setEmployeeCreditRemaining={setEmployeeCreditRemaining}
        setResponsibleDepartment={setResponsibleDepartment}
        setEmployeeResponsibleEmail={setEmployeeResponsibleEmail}
        setEmployeeResponsibleDepartment={setEmployeeResponsibleDepartment}
        setEmployeeDepartmentId={setEmployeeDepartmentId}
        setTeamId={setTeamId}
        setTeamName={setTeamName}
        setExpectedCreditLimit={setExpectedCreditLimit}
        setEmployeeTeamId={setEmployeeTeamId}
        setEmployeeTeamName={setEmployeeTeamName}
        onPageChange={onPageChange}
        isId={false}
      />
      <EditCreditPopup
        showEditCreditPopup={showEditCreditPopup}
        onClosePopup={() => setShowEditCreditPopup(false)}
        creditLimit = {creditLimit}
        creditExhausted = {creditExhausted}
        creditRemaining = {creditRemaining}
        userId={userId}
        departmentId={departmentId}
        departmentName={departmentName}
        userName={userName}
        type={type}
        monthlyAverageRevenue={monthlyAverageRevenue}
        responsibleEmail={responsibleEmail}
        responsibleDepartment={responsibleDepartment}
        teamId={teamId}
        teamName={teamName}
        expectedCreditLimit={expectedCreditLimit}
        />
        <RetagInvoicePopup
        showRetagInvoicePopup={showRetagInvoicePopup}
        onClosePopup={() => setShowRetagInvoicePopup(false)}
        employeeCreditLimit = {employeeCreditLimit}
        employeeCreditRemaining = {employeeCreditRemaining}
        employeeResponsibleEmail={employeeResponsibleEmail}
        employeeResponsibleDepartment={employeeResponsibleDepartment}
        employeeDepartmentId={employeeDepartmentId}
        employeeTeamId={employeeTeamId}
        employeeTeamName={employeeTeamName}
        />
    </Layout>
    </>
  );
};

export default CreditPolicy;
